import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/axios';
import { FEED_ITEM_LIST } from 'src/constants/queryKeys';

export const networkGetAppInfo = async () => {
  const res = await axiosInstance.get('Base/Info');
  return res;
};

export const networkCreateFeed = async (data) => {
  const res = await axiosInstance.post('Feed/Group/Create', data);
  return res;
};

export const networkUpdateFeed = async (feedId, projectId, data) => {
  const res = await axiosInstance.post(`Feed/Group/Update/${feedId}/${projectId}`, data);
  return res;
};

export const networkRemoveFeed = async (feedId, projectId) => {
  const res = await axiosInstance.post(`Feed/Group/Remove/${feedId}/${projectId}`);
  return res;
};

export const networkCreateFeedItem = async (data) => {
  const res = await axiosInstance.post('Feed/Item/Create', data);
  return res;
};

export const networkUpdateFeedItem = async (feedItemId, feedId, data) => {
  const res = await axiosInstance.post(`Feed/Item/Update/${feedItemId}/${feedId}`, data);
  return res;
};

export const networkRemoveFeedItem = async (feedItemId, feedId) => {
  const res = await axiosInstance.post(`Feed/Item/Remove/${feedItemId}/${feedId}`);
  return res;
};

export const networkGetFeedInfo = async (feedId) => {
  const res = await axiosInstance.post(`Feed/Group/Info/${feedId}`);
  return res;
};

export function useFetchFeedInfo(feedId) {
  return useQuery({
    queryKey: ['feed-info', feedId],
    queryFn: () => networkGetFeedInfo(feedId),
  });
}

export const networkGetFeedItems = async (feedId, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`Feed/Item/List/${feedId}/${pageIndex}/${pageSize}`);
  return res;
};

export function useFetchFeedItems(feedId, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [FEED_ITEM_LIST, feedId, pageIndex],
    queryFn: () => networkGetFeedItems(feedId, pageIndex, pageSize),
  });
}

export const networkFeedGroupMove = async (projectId, data) => {
  const res = await axiosInstance.post(`Feed/Group/Move/${projectId}`, data);
  return res;
};

export const networkFeedItemMove = async (projectId, data) => {
  const res = await axiosInstance.post(`Feed/Item/Move/${projectId}`, data);
  return res;
};

// ---------------------------------------------------------------------------------------------

export const networkGetFeedUrlApiTypeList = async (pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`FeedUrlAPIType/List/${pageIndex}/${pageSize}`);
  return res;
};

export function useFetchFeedUrlApiTypeList(pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: ['feed-url-api-type-list', pageIndex],
    queryFn: () => networkGetFeedUrlApiTypeList(pageIndex, pageSize),
  });
}

// ---------------------------------------------------------------------------------------------

export const networkFeedGroupCopy = async (payload) => {
  const res = await axiosInstance.post(`Feed/Group/Copy`, payload);
  return res;
};

export const networkSectionCopy = async (payload) => {
  const res = await axiosInstance.post(`Feed/Group/SectionCopy`, payload);
  return res;
};
